import React from "react";
import { Value } from "../../models/SpecTable";
import { isDefined } from "../../utils";
import FilterOperationBtn from "../buttons/FilterOperationBtn";
import { Item } from "./MultiselectCtrl";
import MultiSelectFilter from "./MultiSelectFilter";
import HelpButton from "../../containers/help/HelpButton";


interface OurProps {
	scopedKeywords: string[]
	filterKeywords: string[]
	setKeywordFilter: (filterKeywords: string[]) => void
}

export const KeywordFilter: React.FunctionComponent<OurProps> = props => {
	const {scopedKeywords, filterKeywords, setKeywordFilter} = props;

	const value: Item[] = filterKeywords.map(kw => ({text: kw, value: kw, helpStorageListEntry: []}));
	const data: Item[] = scopedKeywords
		.map(txt => ({text: txt, value: txt, helpStorageListEntry: []}))
		.filter(item => !value.some(v => v.value == item.value));
	const placeholder = data.length === 1
		? `${data[0].text}`
		: `(${data.length} items)`;
	
	return (
		<>
			<div className="row" style={{marginTop: 10}}>
				<div className="col d-flex justify-content-between">
					<div>
						<label>Keyword</label>
						<HelpButton name={"keywordFilter"} />
					</div>

					<div>
						<FilterOperationBtn
							enabled={value.length > 0}
							filterName="keywordFilter"
							title="Reset this filter"
							baseStyle={{fontSize: 16, marginLeft: 12}}
							iconCls="fas fa-times-circle"
							action={() => setKeywordFilter([])}
						/>
					</div>
				</div>
			</div>
			<div className="row">
				<div className="col-md-12">
					<MultiSelectFilter
						name={"keywordFilter"}
						shouldUseExternalListEntry={false}
						updateFilter={(_: any, keywords: Value[]) => setKeywordFilter(keywords.filter(isDefined).map(kw => kw + ''))}
						placeholder={placeholder}
						data={data}
						value={value}
					/>
				</div>
			</div>
		</>
	);
};
